<template>
  <div>
    <DotLoading v-if="type === 'dot'"/>
    <LvLoadingCard v-else-if="type === 'card'"/>
  </div>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'dot',
    }
  }
}
</script>